(() => {
  document.body.classList.add('ow-commercial-page');

  const hero = document.querySelector('.ow-commercial-hero');
  if (hero && 'IntersectionObserver' in window) {
    const chatObserver = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('ow-commercial-chat-ready', !entry.isIntersecting);
    }, { rootMargin: '-76px 0px 0px 0px', threshold: 0 });
    chatObserver.observe(hero);
  } else {
    document.body.classList.add('ow-commercial-chat-ready');
  }

  const form = document.querySelector('[data-large-order-form]');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');
  const source = params.get('source');
  const support = params.get('support');
  const productField = form.querySelector('[data-large-order-product]');
  const requestField = form.querySelector('[data-large-order-request]');
  const supportFields = [...form.querySelectorAll('[name="contact[support_needed]"]')];
  const supportHint = form.querySelector('[data-project-support-hint]');
  const optionalFields = form.querySelector('.ow-commercial-form__optional');
  const status = form.querySelector('.ow-commercial-status');
  const entryCtaField = form.querySelector('[data-project-entry-cta]');
  const publish = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  };
  const supportHints = {
    'Help me define the right scope': 'Share the project goal, site ZIP, approximate timing, and anything you already have. We will identify the most practical next step.',
    'Plant sourcing only': 'For the strongest source options, include plant names, sizes, quantities, destination ZIP, and required-on-site date.',
    'Sourcing and delivery coordination': 'Include approximate quantities, destination access, timing, and whether you expect one delivery or project phases.',
    '2D plan to 3D concept visualization': 'Open the optional details to add a PDF, CAD, or share link, inspiration references, and the review deadline.',
    'Plant schedule and sourcing support': 'Include the current plant list, size specifications, quantities, revisions, and any acceptable alternates.',
    'Full project support': 'Open the optional details to add the plan link, budget range, quantities, schedule, and delivery access.'
  };
  const updateSupportHint = (value) => {
    if (supportHint && supportHints[value]) supportHint.textContent = supportHints[value];
  };

  const selectedSupport = supportFields.find((field) => field.checked);
  if (selectedSupport) updateSupportHint(selectedSupport.value);

  if (product && productField && !productField.value) productField.value = product.slice(0, 180);
  if (source === 'cart' && requestField) requestField.value = 'Bulk plant sourcing';
  if (source === 'contractor' && requestField) requestField.value = 'Landscape contractor project';
  if (support && supportFields.length) {
    const matchingOption = supportFields.find((option) => option.value === support);
    if (matchingOption) {
      matchingOption.checked = true;
      updateSupportHint(matchingOption.value);
    }
  }

  const attribution = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_content: params.get('utm_content') || '',
    referrer_host: (() => {
      try { return document.referrer ? new URL(document.referrer).hostname : 'direct'; }
      catch { return 'direct'; }
    })(),
    landing_page: window.location.pathname
  };
  Object.entries(attribution).forEach(([key, value]) => {
    const field = form.querySelector('[data-project-attribution="' + key + '"]');
    if (field) field.value = String(value).slice(0, 180);
  });

  document.querySelectorAll('[data-project-cta]').forEach((cta) => {
    cta.addEventListener('click', () => {
      const entry = cta.dataset.projectCta || 'project-page-cta';
      if (entryCtaField) entryCtaField.value = entry;
      publish('commercial_project_cta_click', { project_cta: entry });
    });
  });
  supportFields.forEach((field) => {
    field.addEventListener('change', () => {
      if (field.checked) {
        updateSupportHint(field.value);
        publish('commercial_project_service_select', { project_service: field.value });
      }
    });
  });
  optionalFields?.addEventListener('toggle', () => {
    if (optionalFields.open) publish('commercial_project_optional_details_open');
  });
  form.querySelector('form')?.addEventListener('submit', () => {
    publish('commercial_project_form_submit_attempt', {
      project_type: requestField?.value || 'not-selected',
      project_service: supportFields.find((field) => field.checked)?.value || 'not-selected'
    });
  });

  if (product && optionalFields) optionalFields.open = true;
  if (status) {
    requestAnimationFrame(() => {
      status.scrollIntoView({ behavior: 'smooth', block: 'center' });
      status.focus({ preventScroll: true });
    });
  }
})();
